export default {
  icon_text: 'Suljettu',
  buttons: {
    ok: 'Ok',
  },
};
